<template>
  <div>
    <Navbar :toReset="(url) => this.reset(url)" />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Operasi" :toReset="(url) => this.reset(url)" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />

          <IntroOperasi
            :detailTop="introRalanOperasi.introRalan"
            :detailBottom="introRalanOperasi.introOperasi"
            :steps="steps"
          />
          <div class="d-flex flex-between my-3">
            <h4 class="text-uppercase mb-0">data operasi</h4>
            <div class="d-flex" v-if="operasi.status != 'DIBATALKAN'">
              <router-link
                :to="`/document/${slug}/laporan-operasi?fromTab=${tabActive}`"
                target="_blank"
                class="btn btn-with-icon-left btn-primary text-uppercase mr-2"
              >
                <i class="material-symbols-outlined">file_download</i>
                Download Laporan Operasi
              </router-link>
              <router-link
                :to="
                  `/operasi/form/${$route.params.id_ralan}/edit/${$route.params.id}?fromTab=${tabActive}`
                "
                class="btn btn-with-icon-left btn-secondary text-uppercase"
              >
                <i class="material-symbols-outlined">create</i>
                Ubah Data Operasi
              </router-link>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <b-tabs pills v-model="tabActive">
                <b-tab
                  title="LAPORAN"
                  :active="tabActive == 0"
                  @click="tabActive = 0"
                >
                  <form-laporan
                    :id_ralan="$route.params.id_ralan"
                    :id="$route.params.id"
                    :operasi="operasi"
                    :ralan="ralan"
                    :toReset="(url) => this.reset(url)"
                    v-if="tabActive == 0"
                  />
                </b-tab>
                <b-tab
                  title="TINDAKAN"
                  @click="tabActive = 1"
                  :active="tabActive == 1"
                >
                  <form-tindakan
                    :id_ralan="$route.params.id_ralan"
                    :id="$route.params.id"
                    :operasi="operasi"
                    :ralan="ralan"
                    v-if="tabActive == 1"
                  />
                </b-tab>
                <b-tab
                  title="OBAT DAN ALKES"
                  @click="tabActive = 2"
                  :active="tabActive == 2"
                >
                  <form-obat
                    :id_ralan="$route.params.id_ralan"
                    :id="$route.params.id"
                    :operasi="operasi"
                    :ralan="ralan"
                    v-if="tabActive == 2"
                  />
                </b-tab>
                <b-tab
                  title="DETAIL BIAYA"
                  @click="tabActive = 3"
                  :active="tabActive == 3"
                >
                  <form-biaya
                    :id_ralan="$route.params.id_ralan"
                    :id="$route.params.id"
                    :operasi="operasi"
                    :ralan="ralan"
                    v-if="tabActive == 3"
                  />
                </b-tab>
                <b-tab
                  title="CEKLIS KESELAMATAN"
                  @click="tabActive = 4"
                  :active="tabActive == 4"
                >
                  <div class="row my-3" v-if="tabActive == 4">
                    <div class="col-md-5 offset-md-7">
                      <a
                        :href="`/#/document/${slug}/penandaan-lokasi-operasi`"
                        class="
                          btn btn-with-icon-left btn-outline-secondary
                          text-uppercase
                        "
                        target="_blank"
                        ><i class="material-symbols-outlined">print</i> Download
                        Form Penandaan Lokasi Operasi
                      </a>
                    </div>
                  </div>
                  <form-ceklis
                    :id_ralan="$route.params.id_ralan"
                    :id="$route.params.id"
                    :operasi="operasi"
                    :ralan="ralan"
                    v-if="tabActive == 4"
                  />
                </b-tab>
                <b-tab
                  title="KONDISI PRE DAN POST"
                  @click="tabActive = 5"
                  :active="tabActive == 5"
                >
                  <form-kondisi
                    :id_ralan="$route.params.id_ralan"
                    :id="$route.params.id"
                    :operasi="operasi"
                    :ralan="ralan"
                    v-if="tabActive == 5"
                  />
                </b-tab>
                <b-tab
                  title="SURVEILANS"
                  @click="tabActive = 6"
                  :active="tabActive == 6"
                >
                  <form-surveilans
                    :id_ralan="$route.params.id_ralan"
                    :id="$route.params.id"
                    :operasi="operasi"
                    :ralan="ralan"
                    v-if="tabActive == 6"
                  />
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import IntroOperasi from "@/components/IntroOperasi.vue";

import FormBiaya from "@/components/FormBiaya.vue";
import FormCeklis from "@/components/FormCeklis.vue";
import FormKondisi from "@/components/FormKondisi.vue";
import FormLaporan from "@/components/FormLaporan.vue";
import FormObat from "@/components/FormObat.vue";
import FormSurveilans from "@/components/FormSurveilans.vue";
import FormTindakan from "@/components/FormTindakan.vue";

// import Alert from "@/components/Alert.vue";
import { setOperationIntro, resetForms } from "@/data/helper.js";
// import { HTTP,HTTP_ENC } from "@/config.js";
import { data } from "@/data/OperasiDetail.js";
import { upperForm, leftForm, rightForm } from "@/data/OperasiFormLaporan.js";
import {
  upperFormLaporan,
  leftFormLaporan,
  rightFormLaporan,
  upperFormCeklis,
  leftFormCeklis,
  middleFormCeklis,
  rightFormCeklis,
  costForm,
  upperFormKondisi,
  leftFormKondisi,
  rightFormKondisi,
} from "@/data/OperasiDetail.js";
// import {dataSurveilans} from '@/data/OperasiForm.js';
export default {
  name: "OperasiDetail",
  components: {
    FormBiaya,
    FormCeklis,
    FormKondisi,
    FormLaporan,
    FormObat,
    FormSurveilans,
    FormTindakan,
    Navbar,
    Sidebar,
    PageContentHeader,
    IntroOperasi,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      classes: {
        DIBATALKAN: "danger",
        DIJADWALKAN: "primary",
        "SEDANG DIPERIKSA": "secondary",
        SELESAI: "success",
        "MENUNGGU PEMBAYARAN": "warning",
        "SELESAI DIPERIKSA": "info",
      },
      data: data,
      tabActive: 0,
      upperForm: upperForm,
      leftForm: leftForm,
      rightForm: rightForm,
      upperFormLaporan: upperFormLaporan,
      leftFormLaporan: leftFormLaporan,
      rightFormLaporan: rightFormLaporan,
      upperFormCeklis: upperFormCeklis,
      leftFormCeklis: leftFormCeklis,
      middleFormCeklis: middleFormCeklis,
      rightFormCeklis: rightFormCeklis,
      costForm: costForm,
      upperFormKondisi: upperFormKondisi,
      leftFormKondisi: leftFormKondisi,
      rightFormKondisi: rightFormKondisi,
      detailTop: null,
      operasiLaporan: null,
      introRalanOperasi: { introRalan: {}, introOperasi: [] },
      steps: [],
      ralan: {},
      operasi: {},
      slug: "",
      formSet: {
        id_operasi: null,
        durasi: null,
        id_operasi_ruangan: 1,
        id_dokter_operator: 1,
        id_dokter_anestesi: null,
        // id_dokter_referal: null,
        id_perawat_instrumen: null,
        id_perawat_anestesi: null,
        id_perawat_sirkuler_1: 0,
        id_perawat_sirkuler_2: 0,
        id_perawat_sirkuler_3: 0,
        id_perawat_sirkuler_4: 0,
        id_perawat_sirkuler_5: 0,
        diagnosa_pra_operasi: null,
        diagnosa_post_operasi: null,
        komplikasi: null,
        jumlah_pendarahan: null,
        jaringan_PA: null,
        asal_jaringan: null,
      },
    };
  },
  methods: {
    handleChange(e) {
      if (e.target.type == "file") {
        if (e.target.files && e.target.files.length) {
          this.formSet[e.target.name] = e.target.files[0];
        }
      } else {
        //console.log("====================onchange===========");
        //console.log(e.target.name);
        //console.log(e.target.value);
        //console.log("====================onchange===========");
        this.formSet[e.target.name] = e.target.value;
      }
    },
    reset(url, stay) {
      //console.log('masuk ke reset');
      // if (this.validated) {
      resetForms(
        this.formSet,
        [
          this.upperForm,
          this.leftForm,
          this.rightForm,
          this.upperFormLaporan,
          this.leftFormLaporan,
          this.rightFormLaporan,
          this.upperFormCeklis,
          this.leftFormCeklis,
          this.middleFormCeklis,
          this.rightFormCeklis,
          this.costForm,
          this.upperFormKondisi,
          this.leftFormKondisi,
          this.rightFormKondisi,
        ],
        true,
        this.handleChange
      );
      // }
      let fromTab = this.$route.query.fromTab;
      let backBtn = this.fromUrl.split("?")[0];
      if (!url) {
        if (this.fromUrl && fromTab) {
          let queryString = "?tab=" + fromTab;
          ////console.log(backBtn)
          this.$router.push({ path: backBtn + queryString });
        } else {
          ////console.log(window.history);
          if (backBtn) {
            this.$router.push({ path: backBtn });
          } else {
            this.$router.go(-1);
          }
        }
      } else {
        ////console.log(url);
        if (fromTab) {
          let queryString = "?tab=" + fromTab;
          let backBtn = url.split("?")[0];
          url = backBtn + queryString;
        }
        this.$router.push(url);
      }
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    // this.formSet['id_operasi']=this.$route.params.id;
    // this.data.actionBtn[0].link+=`${this.$route.params.id_ralan}/edit/${this.$route.params.id}`;
    if (this.$route.query.tab) {
      this.tabActive = parseInt(this.$route.query.tab);
    }
    this.data.toReset = (url) => this.reset(url);
    try {
      let result = await this.$store.state.HTTP.get(
        `operasi/${this.$route.params.id}`
      );
      //console.log(result);
      if (result.status == 200) {
        this.operasi = result.data;
        let result2 = await this.$store.state.HTTP.get(
          `ralan/${this.operasi.id_ralan}`
        );
        this.ralan = result2.data;
        this.introRalanOperasi = setOperationIntro(this.ralan, this.operasi);
        this.operasi.ralan = this.ralan;
        //console.log(this.operasi);
        //console.log(this.operasi.status);
        this.$set(this.data, "actionBtn", [
          {
            type: "status",
            className: `badge-${this.classes[this.operasi.status]}`,
            label: this.operasi.status,
          },
        ]);
        //console.log(JSON.stringify(this.operasi));
        this.slug = this.CryptoJS.AES.encrypt(
          JSON.stringify(this.operasi),
          this.$store.state.simrsSecretPassphrase
        )
          .toString()
          .replace(/\//g, "fRWdSl45h");
        //console.log(this.data);
      } else {
        this.displayNotFoundError();
      }
    } catch (e) {
      //console.log(e);
    }
  },
};
</script>
